<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="最大消息长度" prop="queuemaxmsglength">
          <el-input-number v-model="form.queuemaxmsglength"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="最大深度" prop="queuemaxdepth">
          <el-input-number v-model="form.queuemaxdepth"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否自动创建队列" prop="autocreate">
          <el-switch
            v-model="form.autocreate"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
  import rApi from "@/api/senior/seniorconf";
  let datafault = {
  };
  export default {
    components: { rApi },
    props: {
      uuid:""
    },
    data() {
      return {
        form:{
          queuemaxmsglength:104857600,
          queuemaxdepth:999999999,
          threshold:50000,
          autocreate:true
        }
      };
    },
    mounted() {
      if(this.uuid){
        rApi.getPdSenior(this.uuid).then(resp=>{
          var _form = JSON.parse(resp.data);
          this.form.queuemaxmsglength = _form.queuemaxmsglength?_form.queuemaxmsglength:this.form.queuemaxmsglength;
          this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
          this.form.autocreate = _form.autocreate||_form.autocreate===false?_form.autocreate:this.form.autocreate;
          this.form.queuemaxdepth = _form.queuemaxdepth?_form.queuemaxdepth:this.form.queuemaxdepth;
        });
      }
    },
    methods: {
      save(){
        if(this.uuid){
          rApi.doSaveForPdSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
        }
        return this.form;
      }
    }
  };
</script>
<style scoped>
</style>